module.exports = "https://la-static.vkplay.ru/promo/universal/img/pic-2-new.7fd4ea20.png";